import styled from 'styled-components';

const SErrorMessage = styled.div`
  padding: 8px 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  color: #ba1821;
  background-color: #fddadb;

  > svg {
    height: 14px;
    max-height: 14px;
    max-width: 14px;
    min-height: 14px;
    min-width: 14px;
    width: 14px;
  }

  > p {
    flex-grow: 1;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`;

export { SErrorMessage };
